var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as ToggleGroupPrimitive from '@radix-ui/react-toggle-group';
import * as React from 'react';
import { classNames as cn } from '../utils';
import { toggleVariants } from './Toggle';
export const ToggleGroupContext = React.createContext({
    size: 'default',
    variant: 'default',
    equalWidth: false,
});
export function ToggleGroup(_a) {
    var { className, variant, size, equalWidth, children } = _a, props = __rest(_a, ["className", "variant", "size", "equalWidth", "children"]);
    return (_jsx(ToggleGroupPrimitive.Root, Object.assign({ "data-slot": "toggle-group", "data-variant": variant, "data-size": size, className: cn('group/toggle-group border-base-200 flex items-center rounded-lg data-[variant=outline]:shadow-xs', equalWidth ? 'w-full' : 'w-fit', className) }, props, { children: _jsx(ToggleGroupContext.Provider, { value: { variant, size, equalWidth }, children: children }) })));
}
export function ToggleGroupItem(_a) {
    var { className, children, variant, size } = _a, props = __rest(_a, ["className", "children", "variant", "size"]);
    const context = React.useContext(ToggleGroupContext);
    return (_jsx(ToggleGroupPrimitive.Item, Object.assign({ "data-slot": "toggle-group-item", "data-variant": context.variant || variant, "data-size": context.size || size, className: cn(toggleVariants({
            variant: context.variant || variant,
            size: context.size || size,
        }), 'border-base-200 shrink-0 rounded-none shadow-none first:rounded-l-lg last:rounded-r-lg focus:z-10 focus-visible:z-10 data-[variant=outline]:border-l-0 data-[variant=outline]:first:border-l', context.equalWidth && 'min-w-0 flex-1', className) }, props, { children: children })));
}
